<ion-loading [isOpen]="loaderService.isLoading | async" [message]="loaderService.loaderText"></ion-loading>